import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'ops_slack_channel',
  label: {
    default: 'OPS slack channel',
    short: 'OPS',
  },
});
